import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c9c6ucjohv: FaireBrandEntity = {
  token: "b_c9c6ucjohv",
  type: "brand",
  name: "Los Angeles Salt Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/4abafc9ccf41d3d4512982a0d00be25ad2c8848a0b2380e9cba938fb2a2079b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1ba2b4f244c10fe3acb7d51ce5a7cc25a5fcce216fe1126352e1af2e1c14da4b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4abafc9ccf41d3d4512982a0d00be25ad2c8848a0b2380e9cba938fb2a2079b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1ba2b4f244c10fe3acb7d51ce5a7cc25a5fcce216fe1126352e1af2e1c14da4b.png",
  location: "Carson, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 70,
  isTopShop: true,
  isInsider: true,
  description:
    "Rooted in three generations of experience in the salt and ingredients industry, LA SALT CO blends deep scientific knowledge with a passion for clean, effective skincare. As a woman-founded, AAPI-owned, and family-operated brand based in Los Angeles, we handcraft every product with integrity, care, and purpose.\n\nOur mineral-rich formulas are powered by the Salts of the Earth, each selected for its unique healing properties, to help you feel and look your best. We create potent, results-driven skincare using only safe, non-toxic, vegan, and cruelty-free ingredients. Free from synthetic fragrances, dyes, parabens, and harsh chemicals, our products are designed to elevate your bath and body rituals without compromise.\n\nAs lifelong animal lovers, we proudly test on ourselves, never on animals, and are honored to be Leaping Bunny certified.\n\nWhy Salt?\n\nSalt has been revered for centuries as a powerful natural remedy. From soothing sore muscles and calming skin conditions to enhancing circulation and promoting glow, salts have played a vital role in ancient wellness rituals. Even Queen Cleopatra was known to bathe in Dead Sea salt for its rejuvenating, anti-acne, and anti-aging benefits. Inspired by this timeless wisdom, we carefully source and blend Earth’s most beneficial salts to support every step of your self-care ritual, from exfoliation to restoration.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:23.190Z",
    importedBy: "entity-db-cli",
  },
};
